import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { getBotspec } from 'data/selectors';
import { isNotEmpty } from 'utils';
import { fetchGlobalVariables } from 'data/actions/globalVariables';
import OptionsBarView from './lib/OptionsBarView';

const buildNodes = (key, prefix, nodes) => ({
  key,
  label: key.charAt(0).toUpperCase() + key.slice(1),
  nodes: Object.keys(nodes).reduce((accum, id) => {
    accum.push({ key: `${prefix}${id}`, label: id });
    return accum;
  }, []),
});

const OptionsBar = ({
  children, childrenValue = '', childrenRef, disabled = false, optionsVisible = false,
}) => {
  const dispatch = useDispatch();
  const botspec = useSelector(getBotspec);
  const [globalVariables, setGlobalVariables] = useState({});

  useEffect(() => {
    dispatch(fetchGlobalVariables())
      .then((vars) => {
        setGlobalVariables(vars || {});
      })
      .catch(() => {
        setGlobalVariables({});
      });
  }, [dispatch]);

  const buildTreeData = () => {
    const specJson = botspec && botspec.spec_json ? botspec.spec_json : {};

    if (isNotEmpty(specJson)) {
      const { variables } = specJson;

      const session = (
        isNotEmpty(variables.session)
        && [{ ...buildNodes('session', '', variables.session) }]
      ) || [];
      const chatbot = (
        isNotEmpty(variables.chatbot)
        && [{ ...buildNodes('chatbot', '_', variables.chatbot) }]
      ) || [];
      const user = (
        isNotEmpty(variables.user)
        && [{ ...buildNodes('user', 'user_', variables.user) }]
      ) || [];
      const global = (
        isNotEmpty(globalVariables)
        && [{ ...buildNodes('global', 'global_', globalVariables) }]
      ) || [];

      return [...session, ...chatbot, ...user, ...global];
    }

    return [];
  };

  return (
    <OptionsBarView
      treeData={buildTreeData()}
      childrenValue={childrenValue}
      childrenRef={childrenRef}
      disabled={disabled}
      optionsVisible={optionsVisible}
    >
      {children}
    </OptionsBarView>
  );
};

OptionsBar.propTypes = {
  children: PropTypes.node.isRequired,
  childrenValue: PropTypes.string,
  childrenRef: PropTypes.shape({
    current: PropTypes.shape({
      value: PropTypes.string,
      selectionStart: PropTypes.number,
      maskInsert: PropTypes.func,
      insert: PropTypes.func,
    }),
  }).isRequired,
  disabled: PropTypes.bool,
  optionsVisible: PropTypes.bool,
};

export default OptionsBar;
